import React, { useEffect, useState } from "react";
import { HomeOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  theme,
  Space,
  Badge,
  Avatar,
  Dropdown,
  Breadcrumb,
  Flex,
  Drawer,
  Form,
  Input,
  Select,
  Switch,
  Row,
  Col,
  Typography,
} from "antd";
import Logo from "../../assets/image/logo/Octaplex Logo.png";
import { LOGO } from "../../layout/style";
import { SIZES } from "../../theme/constant";
import { useSelector, useDispatch } from "react-redux";
import { loginCompany, logout } from "../../redux/slices/authSlice";
import { Outlet, useNavigate } from "react-router-dom";

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;

const ServerDown = ({ toggleTheme, getTheme }) => {
  const navigate = useNavigate();

  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorPrimaryHover,
      colorPrimaryBorderHover,
      colorPrimaryBorder,
      colorPrimaryBgHover,
      colorBgBase,
    },
  } = theme.useToken();

  const styles = {
    svg: {
      font: "20.5em 'Monoton'",
    },
    heading: {
      //   textAlign: 'center',
      font: "1.5em 'Roboto', sans-serif",
      fontWeight: "bold",
      color: colorPrimary,
      opacity: 0.6,
    },
    link: {
      display: "inline-block",
      textTransform: "uppercase",
      font: "1em 'Roboto'",
      fontWeight: 300,
      border: `1px solid ${colorPrimary}`,
      borderRadius: "4px",
      color: "#2f8f7f",
      margin: "15px 0",
      padding: "8px 14px",
      textDecoration: "none",
      opacity: 0.6,
    },
    text: (color, delay) => ({
      fill: "none",
      strokeDasharray: "8% 29%",
      strokeWidth: "5px",
      strokeDashoffset: "1%",
      stroke: color,
      animation: `strokeOffset 5.5s infinite linear`,
      animationDelay: delay,
    }),
  };

  return (
    <Layout style={{ height: "100svh", overflowY: "auto" }}>
      <Content style={{ overflowY: "auto" }}>
        <Row>
          <Col
            xs={{
              span: 20,
              offset: 2,
            }}
            md={{
              span: 18,
              offset: 4,
            }}
            lg={{
              span: 18,
              offset: 4,
            }}
          >
            <Flex vertical={true} justify="" style={{ height: "100svh" }}>
              <div>
                <img
                  src={Logo}
                  height="36px"
                  width="auto"
                  alt=""
                  style={LOGO.warpper}
                />
              </div>
              <Row>
                <Col span={24}>
                  <div
                    style={{
                      height: 5,
                      backgroundColor: colorPrimary,
                      marginTop: 20,
                    }}
                  ></div>
                </Col>
              </Row>
              <Content>
                <div style={styles.content}>
                  <svg viewBox="0 0 960 300" style={styles.svg}>
                    <symbol id="s-text">
                      <text textAnchor="middle" x="30%" y="90%">
                        404
                      </text>
                    </symbol>

                    <g className="g-ants">
                      <use
                        xlinkHref="#s-text"
                        style={styles.text(colorPrimaryBgHover, "-1s")}
                      ></use>
                      <use
                        xlinkHref="#s-text"
                        style={styles.text(colorPrimaryBorder, "-2s")}
                      ></use>
                      <use
                        xlinkHref="#s-text"
                        style={styles.text(colorPrimaryBorderHover, "-3s")}
                      ></use>
                      <use
                        xlinkHref="#s-text"
                        style={styles.text(colorPrimaryHover, "-4s")}
                      ></use>
                      <use
                        xlinkHref="#s-text"
                        style={styles.text(colorPrimary, "-5s")}
                      ></use>
                    </g>
                  </svg>
                </div>
                <br />
                <Text style={{ fontSize: 48, fontWeight: 400 }}>
                  <span style={{ color: colorPrimary, fontSize: 54 }}>
                    Sorry!,
                  </span>{" "}
                  this page isn't available
                </Text>
                <br />
                <Text
                  type="secondary"
                  style={{ fontSize: 24, fontWeight: 400 }}
                >
                  Unable to connect to the server. Please try again later.
                </Text>
                <br />
                <br />
                <Flex align="center" gap={16} justify="flex-start">
                  <Button
                    size="large"
                    type="default"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </Button>
                  <Button
                    size="large"
                    type="primary"
                    icon={<HomeOutlined />}
                    onClick={() => navigate("/Home")}
                  >
                    HomePage
                  </Button>
                </Flex>
              </Content>
            </Flex>
          </Col>
        </Row>
        <Row></Row>
      </Content>
      {/* Keyframes for animation */}
      <style>{`
        @keyframes strokeOffset {
          100% {
            stroke-dashoffset: -35%;
          }
        }
      `}</style>
    </Layout>
  );
};
export default ServerDown;
